<template>
  <div class="container">
    <!-- 서브상단영역 -->

    <Banner
      title="etc"
      subtitle="etc"
      description="학생들과 함께 그들의 미래를 찾는 일을 하고자 합니다. <br>
        자신의 미래에 관심이 있는 학생 누구에게나 도움을 주고자 합니다."
    />

    <Navbar />

    <div class="width_wrap">
      <Sidebar />
      <div class="body_content sub">
        <!-- 서브 타이틀영역 -->
        <h1 class="sub_subject">오시는 길<span></span></h1>
        <!-- //서브 타이틀영역 -->

        <div class="map">
          <div class="location">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3212.364770575075!2d127.3897800765489!3d36.37616267237103!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x356549915464da7d%3A0x4058b6419f83a138!2z7Juw7Lig7YOA7JuM!5e0!3m2!1sko!2skr!4v1749720495619!5m2!1sko!2skr"
              width="600"
              height="450"
              style="border: 0"
              allowfullscreen=""
              loading="lazy"
              referrerpolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
          <div class="map_addr">
            <dl>
              <dt style="display: inline-flex; align-items: center">
                <n-icon size="16" style="margin-right: 10px"
                  ><LocationSharp
                /></n-icon>
                주소
              </dt>
              <dd>
                대전 유성구 엑스포로123번길 27-22 (도룡동) KCC 웰츠타워 101동
                1107호
              </dd>
            </dl>

            <dl>
              <dt style="display: inline-flex; align-items: center">
                <n-icon size="16" style="margin-right: 10px"><Call /></n-icon>
                전화번호
              </dt>
              <dd>042-867-5558</dd>
            </dl>

            <dl>
              <dt style="display: inline-flex; align-items: center">
                <n-icon size="16" style="margin-right: 10px"><Print /></n-icon
                >팩스
              </dt>
              <dd>042-867-7228</dd>
            </dl>

            <dl>
              <dt style="display: inline-flex; align-items: center">
                <n-icon size="16" style="margin-right: 10px"
                  ><MailSharp
                /></n-icon>
                이메일
              </dt>
              <dd>admin@cokolab.com</dd>
            </dl>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import Navbar from "@/views/etc/Navbar.vue";
import Sidebar from "@/views/etc/page/Sidebar.vue";
import Banner from "@/components/Banner.vue";
import { USER_ROUTES } from "@/assets/route_constants.ts";
import { NIcon } from "naive-ui";
import { LocationSharp, Call, Print, MailSharp } from "@vicons/ionicons5";

const isOpen = ref(false);

// 토글 함수
function toggleRow() {
  isOpen.value = !isOpen.value;
}
</script>

<style scoped>
.scbd .sp-ico {
  background-image: url("@/assets/img_up/shop_pds/kp708b/design/rwdClear/sp-icons@2x.png");
  background-size: 300px 250px;
}

.sub_title_01 p {
  position: absolute;
  top: 70px;
  left: 0;
  margin-top: -15px;
  width: 100%;
  font-size: 30px;
  color: #fff;
  text-align: center;
  font-family: "Noto Sans", "Nanum Gothic", "Malgun Gothic", sans-serif;
  font-weight: 600;
}
.sub_title_01 h2 {
  position: absolute;
  top: 130px;
  left: 0;
  margin-top: -15px;
  width: 100%;
  font-size: 19px;
  color: #fff;
  text-align: center;
  font-family: "Noto Sans", "Nanum Gothic", "Malgun Gothic", sans-serif;
  font-weight: 500;
  line-height: 1.7em;
}

.map * {
  font-family: "Montserrat", "Noto Sans", NanumGothic, "나눔고딕", "Open Sans",
    sans-serif;
  box-sizing: border-box;
}
.map {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
}
.map > div.location {
  width: 100%;
  margin-bottom: 20px;
}
.map > div.location iframe {
  display: block;
}
.map > div.map_addr {
  width: 100%;
}
.map_addr dl {
  font-size: 14px;
}
.map_addr dl:nth-child(-n + 3) {
  margin-bottom: 20px;
}
.map_addr dl dt {
  font-weight: 600;
  margin-bottom: 10px;
  color: #015bb1;
}
.map_addr dl dt i {
  font-family: "Font Awesome 6 Free";
  padding-right: 10px;
  font-size: 15px;
}
.map_addr dl dd {
  box-sizing: border-box;
  line-height: 1.7em;
}
@media screen and (min-width: 768px) {
  .map > div.location {
    width: 60%;
    margin-bottom: 0;
  }
  .map > div.map_addr {
    width: 38%;
  }
  .map_addr dl {
    padding: 0px 15px;
    font-size: 15px;
  }
  .map_addr dl dt {
  }
  .map_addr dl:nth-child(-n + 3) {
    margin-bottom: 40px;
  }
}

@media screen and (min-width: 1100px) {
}
</style>
